(function () {

function render_product () {
  const main_product = document.getElementsByClassName('shopify-section--main-product')[0];

  const need_breadcrumb = document.createElement('div');
  need_breadcrumb.innerHTML = window_api_data.need_breadcrumb;
  need_breadcrumb.className = 'need_breadcrumb';
  main_product.before(need_breadcrumb);
  
  const product_info_title = document.getElementsByClassName('product-info__block-item')[0];
  product_info_title.innerHTML = window_api_data.product_title;
  
  const price_cont = document.getElementsByClassName('product-info__block-item')[1];

  if (window_api_data.product_type == 'FINS') {
    render_fins_detail(price_cont);

    /* Audio off until assets ready
    const description_el = document.querySelector('div[data-block-type="description"]');
    render_fin_audio(description_el);
    */
  }
  else {
    render_size_calculator(price_cont);
  }
  render_need_help(price_cont);
  
  const size_calc_cont = document.createElement('div');
  
  const product_cont = document.createElement('div');
  product_cont.className = 'product_cont';
  main_product.after(product_cont);
  
  if (window_api_data.product_top_video) {
    const product_top_video = document.createElement('div')
    product_top_video.className = 'product-video-cont'
    product_cont.appendChild(product_top_video)

    if (window_api_data.product_top_video.endsWith('.mp4')) {
      const product_video = document.createElement('video')
      product_video.className = 'product-video'
      product_video.src = window_api_data.product_top_video
      product_video.controls = true
      product_video.autoplay = true
      product_top_video.appendChild(product_video)
    } else {
      const product_iframe = document.createElement('iframe')
      product_iframe.className = 'product-video'
      product_iframe.src = window_api_data.product_top_video + '?rel=0&modestbranding=1&playsinline=1'
      product_iframe.frameBorder = 0
      product_iframe.allow = 'fullscreen'
      product_top_video.appendChild(product_iframe)
    }
  }

  const product_images_el = document.createElement('div');
  product_images_el.className = 'product_images';
  product_cont.appendChild(product_images_el);

  var col_count = 0;
  
  for (let i=0; i<window_api_data.product_images.length; i++) {
    const media = window_api_data.product_images[i];

    if (media.aspect_ratio > 1.77) {
      col_count = 1;
    } else {
      col_count++;
    }

    const media_cont = document.createElement('div');
    media_cont.className = 'media_cont ' + (media.aspect_ratio > 1.77 ? 'media_cont_wide ' : '') + (col_count == 1 ? 'media_cont_clear' : '');
    product_images_el.appendChild(media_cont);

    if (col_count >= 2 || media.aspect_ratio > 1.77) {
      col_count = 0;
    }

    if (media.media_type == 'video') {
      const video = document.createElement('video');
      video.src = media.url;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = "loop";
      video.autoplay = true;
      media_cont.appendChild(video);

      video.addEventListener('loadedmetadata', function () {
        video.play();
      });
    }
    else {
      const img = document.createElement('img');
      img.src = media.url;
      img.alt = media.alt;
      media_cont.appendChild(img);
    }
  }

  const product_bottom_el = document.createElement('div');
  product_bottom_el.innerHTML = window_api_data.product_bottom;
  product_bottom_el.className = 'product_bottom';
  product_cont.appendChild(product_bottom_el);
  
  // judge.me review panel adjust background
  const judge_div = document.getElementById('judgeme_product_reviews');
  if (judge_div) {
    var bg_color_div = judge_div.closest('.color-scheme');
    if (bg_color_div) {
      bg_color_div.style.backgroundColor = '#ffffff';
      bg_color_div.style.border = 'None';
    }
  }
}

window.render_product = render_product;

})()
